import { matchRoutes, useLocation } from "react-router-dom";
import { Routes } from "@router/index";

export const useCurrentPath = () => {
	const location = useLocation();
	return matchRoutes(Routes, location)?.find((m) => m.pathname === location.pathname);
};
